import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DivisionIcon, VCIcon } from '../Buttons/TypeIcons';
import Button from './Button';
import colours from './Colours';
import HighLighter from './HighLighter';
import Icon from './Icons/Icon';
import { CaptionMedium, CaptionSmall, P2Bold, P3, P3Bold, P4 } from './Text';

const VehicleResultCard = (props) => {

    let { vehicle, search_term } = props;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    }

    useEffect(()=> {
        window.addEventListener('resize', handleResize);

        return (()=> {
            window.removeEventListener('resize', handleResize);
        })
    })

    return (
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <div style={{height: 40, maxHeight: 40, width: 72, maxWidth: 72, backgroundColor: 'white', margin: 8, borderRadius: 4, overflow: 'hidden'}}>
                {vehicle.Photos ? 
                    <img src={"https://s3.ca-central-1.amazonaws.com/digitalvms/vehicle-images/" + vehicle.Photos} style={{height: 40, objectFit: 'cover', width: 72}} />
                    : <div style={{height: 40, maxHeight: 40, width: 72, maxWidth: 72,  backgroundColor: 'grey'}}></div>
                }
            </div>
            <div style={{display: 'flex', flexDirection: windowWidth <= 768 ? 'column' : 'row', flex: 1}}>
                <div>
                    <P2Bold style={{color: colours.primary.grey01, marginBottom: 4}}>
                        <HighLighter 
                            text={vehicle.Year + " " + vehicle.Make + " " + vehicle.Model + " " + vehicle.Trim} 
                            searchTerm={search_term} 
                            highlightedItemClass="ds-highlighted-search-text" 
                            itemClass="ds-non-highlighted-search-text"
                            />
                    </P2Bold>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <div style={{display: 'flex'}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                {VCIcon(vehicle.vmh, 14, "true", null, true)}
                                <P3Bold>{vehicle.vmh.Display_Name + " - " + vehicle.vmh.Display_City}</P3Bold>
                            </div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', marginLeft: 16}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                {DivisionIcon(vehicle.stakeholder, 14, "true", null, true)}
                                <P3Bold>{vehicle.stakeholder.Division} Division</P3Bold>
                            </div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', marginLeft: 16}}>
                            <div style={{display: 'flex', alignItems: 'center'}} data-tip="Mileage" data-tooltip>
                                <Icon name="Mileage" size={16} style={{color: colours.primary.blue, marginRight: 4}} />
                                <P3Bold>{new Intl.NumberFormat().format(vehicle.Odometer)} KM</P3Bold>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div style={{display: 'flex', flex: 1,  justifyContent: windowWidth <= 768 ? 'flex-start' : 'flex-end', height: 40}}>
                    <div style={{display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center'}}>
                        <P3 style={{textAlign: windowWidth <= 768 ? 'start' : 'end', marginTop: windowWidth <= 768 ? 8 : 0}}>
                            <HighLighter 
                                text={vehicle.VIN} 
                                searchTerm={search_term} 
                                highlightedItemClass="ds-highlighted-search-text" 
                                itemClass="ds-non-highlighted-search-text-lightgrey"
                                />
                        </P3>
                        {vehicle.License_Plate ? 
                        <P3 style={{textAlign: 'end', marginTop: 8}}>
                            <HighLighter 
                                text={String(vehicle.License_Plate).toUpperCase()} 
                                searchTerm={search_term} 
                                highlightedItemClass="ds-highlighted-search-text" 
                                itemClass="ds-non-highlighted-search-text-lightgrey"
                                />
                        </P3> : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

const SelectedVehicleCard = (props) => {
    let { vehicle } = props;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    }

    useEffect(()=> {
        window.addEventListener('resize', handleResize);

        return (()=> {
            window.removeEventListener('resize', handleResize);
        })
    })
    
    if (props.vehicle) {
        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderRadius: 8, border: `solid 1px ${colours.primary.grey02}`, backgroundColor: colours.primary.grey05}}>
                <div style={{height: 40, maxHeight: 40, width: 72, maxWidth: 72, backgroundColor: 'white', margin: 8, borderRadius: 4, overflow: 'hidden'}}>
                    {vehicle.Photos ? 
                        <img src={"https://s3.ca-central-1.amazonaws.com/digitalvms/vehicle-images/" + vehicle.Photos} style={{height: 40, objectFit: 'cover', width: 72}} />
                        : <div style={{height: 40, maxHeight: 40, width: 72, maxWidth: 72,  backgroundColor: 'grey'}}></div>
                    }
                </div>
                <div style={{display: 'flex', flexDirection: windowWidth <= 768 ? 'column' : 'row', flex: 1}}>
                    <div>
                        <P2Bold style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', color: colours.primary.grey01, marginBottom: 4, marginLeft: 4}}>
                            {vehicle.Year + " " + vehicle.Make + " " + vehicle.Model + " " + vehicle.Trim}
                        </P2Bold>
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                            <div style={{display: 'flex'}}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    {VCIcon(vehicle.vmh, 14, "true", null, true)}
                                    <P3Bold>{vehicle.vmh.Display_Name + " - " + vehicle.vmh.Display_City}</P3Bold>
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', marginLeft: 16}}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    {DivisionIcon(vehicle.stakeholder, 14, "true", null, true)}
                                    <P3Bold>{vehicle.stakeholder.Division} Division</P3Bold>
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', marginLeft: 16}}>
                                <div style={{display: 'flex', alignItems: 'center'}} >
                                    <div data-tip="Mileage" data-tooltip style={{display: 'flex', alignItems: 'center'}}>
                                        <Icon name="Mileage" size={16} style={{color: colours.primary.blue, marginRight: 4}} />
                                    </div>
                                    <P3Bold>{new Intl.NumberFormat().format(vehicle.Odometer)} KM</P3Bold>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div style={{display: 'flex', flex: 1,  justifyContent: 'flex-end', height: 40, marginRight: 8}}>
                        <div style={{display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center'}}>
                            <P3 style={{textAlign: windowWidth <= 768 ? 'start' : 'end', marginTop: windowWidth <= 768 ? 8 : 0, color: colours.primary.grey01}}>
                                {vehicle.VIN}
                            </P3>
                            {vehicle.License_Plate ? 
                                <P3 style={{textAlign: 'end', marginTop: 8, color: colours.primary.grey01}}>
                                    {String(vehicle.License_Plate).toUpperCase()}
                                </P3> 
                            : null}
                        </div>
                    </div>
                </div>
                {props.onClose ? <div style={{cursor: 'pointer', width: 36, display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={props.onClose}>
                    <Icon name="Close" size={24}/>
                </div> : null}
            </div>
        )
    } else {
        return null;
    }
}

const BookingCard = (props) => {
    let { booking } = props;

    let releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    let returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    if (booking.Released_On) {
        releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        
        if (booking.Returned_On) {
            returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        }
    }

    
    if (props.booking) {
        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderRadius: 8, border: `solid 1px ${colours.primary.grey04}`, backgroundColor: 'white', minHeight: '46px', marginTop: '8px'}}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', margin: '8px'}}>
                    <Icon name={booking.Book_Type == 2 ? 
                        "Car" : booking.profile.Is_User == 1 ? "User" : "Tag"} size={24} style={{ borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue }}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                    <P3Bold style={{textAlign: 'start', color: colours.primary.grey01, marginBottom: 4, marginLeft: 0}}>
                        {booking.profile.First_Name + ' ' + booking.profile.Last_Name}
                    </P3Bold>                        
                    <P4 style={{textAlign: 'start', color: colours.primary.grey02, marginLeft: 0}}>
                        {booking.profile.Title + (booking.profile.Company ? ' at ' + booking.profile.Company : '')}
                    </P4>
                </div>
                <div style={{display: 'flex', flex: 1,  justifyContent: 'flex-end', height: 40, marginRight: 8}}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Icon name="Release" size={24} style={releaseIconContainerStyle}/>
                        <div style={{textAlign: 'left', marginLeft: 4, width: 78}}>
                            <P3Bold>{moment(booking.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                            <CaptionSmall>{moment(booking.Start_Date + " " + booking.Release_Time).format('hh:mm a')}</CaptionSmall>
                        </div>
                        <Icon name="ArrowRight" size={24} style={{marginLeft: 0, marginRight: 4}}/>
                        <Icon name="CheckIn" size={24} style={returnIconContainerStyle}/>
                        <div style={{textAlign: 'left', marginLeft: 4, width: 78}}>
                            <P3Bold>{moment(booking.End_Date).format('MMM DD, YYYY')}</P3Bold>
                            <CaptionSmall>{moment(booking.End_Date + " " + booking.Return_Time).format('hh:mm a')}</CaptionSmall>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: '76px'}}>
                        <Button label={props.action == 'cancel' ? "Cancel" : props.action == 'return' ? "Check In" : "Dismiss"} leading_ic={props.action == 'return' ? 'ArrowRight' : 'XCircle'} red={!props.return} tertiary small color={props.action == 'return' ? null : colours.accent.error_red} onClick={props.onAction}/>
                    </div>
                </div>
                {props.onClose ? <div style={{cursor: 'pointer', width: 36, display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={props.onClose}>
                    <Icon name="Close" size={24}/>
                </div> : null}
            </div>
        )
    } else {
        return null;
    }
}

const ReminderCard = (props) => {
    let reminder_categories = ['Service', 'Insurance', 'License', 'Termination'];

    let { reminder, odometer } = props;
    
    let is_activated = reminder.Remind_Date ? 
                            moment().isAfter(reminder.Remind_Date, 'YYYY-MM-DD') 
                        : false; 

    if (reminder.Remind_km && odometer >= reminder.Remind_km) 
        is_activated = true;
    
    if (props.reminder) {
        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderRadius: 8, border: `solid 1px ${colours.primary.grey04}`, backgroundColor: 'white', minHeight: '46px', marginTop: '8px'}}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', margin: '8px'}}>
                    <Icon name={"Reminder"} size={24} style={{ borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue }}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                    <P3Bold style={{textAlign: 'start', color: colours.primary.grey01, marginBottom: 0, marginLeft: 0}}>
                        {reminder_categories[reminder.Category] + ' - '}
                        {
                            reminder.Remind_Date ?
                                moment(reminder.Remind_Date).format("MMM DD, YYYY")
                            : null
                        }
                        {
                            reminder.Remind_Date && reminder.Remind_km ?
                                "/"
                            : null
                        }
                        {
                            reminder.Remind_km ?
                                new Intl.NumberFormat().format(reminder.Remind_km) + ' KM'
                            : null
                        }
                    </P3Bold>
                </div>
                <div style={{display: 'flex', flex: 1,  justifyContent: 'flex-end', height: 40, marginRight: 8}}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', maxWidth: 84, marginRight: 16}}>
                        <Icon name={is_activated ? "Reminder" : "Upcoming"} size={16} style={{ borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue }}/>
                        <CaptionMedium style={{color: colours.primary.grey02, marginLeft: 4}}>{is_activated ? "Activated" : "Upcoming"}</CaptionMedium>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: '76px'}}>
                        <Button label={props.action == 'cancel' ? "Cancel" : "Dismiss"} leading_ic='XCircle' red tertiary small color={colours.accent.error_red} onClick={props.onAction}/>
                    </div>
                </div>
                {props.onClose ? <div style={{cursor: 'pointer', width: 36, display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={props.onClose}>
                    <Icon name="Close" size={24}/>
                </div> : null}
            </div>
        )
    } else {
        return null;
    }
}

export {VehicleResultCard, SelectedVehicleCard, BookingCard, ReminderCard};